<template>
  <div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        numberOfSteps: 3,
      }
    },
    props: {
      hasRelatedPlaces: {
        required: true,
        default: false,
      }
    },
    created() {
      if(this.hasRelatedPlaces) {
        this.numberOfSteps = 4;
      }
    },
    mounted() {
      this.$nextTick(() => {
        const tour = this.$shepherd({
          useModalOverlay: true,
          defaultStepOptions: {
            classes: 'shepherd-element shepherd-open shepherd-theme-arrows',
            scrollTo: true,
            cancelIcon: {
              enabled: true,
              label: 'Luk vejledning'
            },
            when: {
              cancel: () => {
                //console.log('placeTutorialCancel');
                localStorage.setItem('OdenseRundt-TutorialPlace', 'false');
                this.$HelperFunctions.trackSession('place-tutorial', 'place-tutorial-closed');
                //app.placeTutorialActive = false;
              }
            }
          }
        });

        tour.addStep({
          id: 'place-menubar',
          text: '<span id="place-tutorial-anchor" aria-label="Stedside tutorial"></span><span class="material-icons icon-medium">favorite_border</span> Tilføj favoritter ved at klikke på hjertet.<br><br>\
          <span class="material-icons icon-medium">playlist_add</span> Du kan også føje til dine egne samlinger ved at klikke på samling.<br><br>\
          <span class="material-icons icon-medium">camera_alt</span>/<span class="material-icons icon-small">pin_drop</span> Skift mellem billede og kort.<br><br>\
          <span class="material-icons icon-medium">share</span> Del på sociale medier og mail.<br><br>\
          <span class="material-icons icon-medium">report_problem</span> Tip os om fejl og mangler.\
          <br><div class="tutorial-step-counter">1/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '.toolbar',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('place-tutorial', 'place-menubar-next');
              }
            }
          ]
        });

        tour.addStep({
          id: 'place-address',
          text: 'Stedets addresse. Klik på <strong>Rute til</strong> <span class="material-icons icon-small">directions</span> for at få beregnet ruten.\
          <br><div class="tutorial-step-counter">2/'+this.numberOfSteps+'</div>',
          attachTo: {
            element: '.place-info',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('place-tutorial', 'place-route-to-next');
              }
            }
          ]
        });

        if(this.hasRelatedPlaces) {
          //Place tags
          tour.addStep({
            id: 'place-tags',
            text: 'Temaer, som stedet hører ind under. Klik på et tema for at gå til tema-oversigten.\<br><div class="tutorial-step-counter">3/'+this.numberOfSteps+'</div>',
            attachTo: {
              element: '.place-tags',
              on: 'bottom'
            },
            buttons: [
              {
                text: 'Tilbage',
                classes: 'shepherd-button-secondary',
                action: tour.back
              }, {
                text: 'Næste',
                classes: 'shepherd-button-primary blue',
                action: () => {
                  tour.next();
                  this.$HelperFunctions.trackSession('place-tutorial', 'place-tags-next');
                }
              }
            ]
          });

          //Place related places
          var attach = (this.$DeviceCheck.isMobile) ? '#place-related-mobile' : '#place-related-pc';
          tour.addStep({
            id: 'place-related',
            text: 'Steder, som er relaterede til det valgte sted, fx parkeringspladser i nærheden.<br><div class="tutorial-step-counter">4/'+this.numberOfSteps+'</div>',
            attachTo: {
              element: attach,
              on: 'bottom'
            },
            buttons: [
              {
                text: 'Tilbage',
                classes: 'shepherd-button-secondary',
                action: tour.back
              }, {
                text: 'Luk',
                classes: 'shepherd-button-primary blue',
                action: () => {
                  tour.complete();
                  //console.log('placeTutorialComplete');
                  localStorage.setItem('OdenseRundt-TutorialPlace', 'false');
                  this.$HelperFunctions.trackSession('place-tutorial', 'place-tutorial-complete');
                  //app.placeTutorialActive = false;
                }
              }
            ]
          });
        }
        else {
          //Place tags
          this.step++;
          tour.addStep({
            id: 'place-tags',
            text: 'Temaer, som stedet hører ind under. Klik på et tema for at gå til tema-oversigten.<br><div class="tutorial-step-counter">3/'+this.numberOfSteps+'</div>',
            attachTo: {
              element: '.place-tags',
              on: 'bottom'
            },
            buttons: [
              {
                text: 'Tilbage',
                classes: 'shepherd-button-secondary',
                action: tour.back
              }, {
                text: 'Luk',
                classes: 'shepherd-button-primary blue',
                action: () => {
                  tour.complete();
                  //console.log('placeTutorialComplete');
                  localStorage.setItem('OdenseRundt-TutorialPlace', 'false');
                  this.$HelperFunctions.trackSession('place-tutorial', 'place-tutorial-complete');
                  //app.placeTutorialActive = false;
                }
              }
            ]
          });
        }
        tour.start();
        /*app.placeTutorialActive = true;
        app.setScreenReaderFocus('place-tutorial-anchor');*/
      });
    }
  };
</script>
